import React, { useCallback, useEffect, useState } from "react";
import SettingList from "../../../../../component-controller-mod/component-serv/list-fs-cp/media-list-op/ts/setting-list-tier";
import { MockSetAttachment, getAttachmentSettings } from "./setting-attachment.type";
import { useSettingsDraft } from "../../../../../context-controller-mod/context-serv/global-provider/setting-context/settings-draft.context";

const PAGE_KEY = "attachments";

const AttahcmentSet = () => {
  const { getInput, setInput, hydrateMany } = useSettingsDraft();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let alive = true;

    const run = async () => {
      try {
        setLoading(true);
        const res = await getAttachmentSettings();
        if (!alive) return;

        const s = res.data.data.settings;

        hydrateMany({
          pageKey: PAGE_KEY,
          inputs: [{ groupId: 1, itemId: 1, value: String(s.maxSizeMb ?? "") }],
        });
      } catch (e) {
        console.error("GET attachment settings failed:", e);
      } finally {
        if (alive) setLoading(false);
      }
    };

    run();
    return () => {
      alive = false;
    };
  }, [hydrateMany]);

  const getInputValue = useCallback(
    (groupId: number, itemId: number) => getInput(PAGE_KEY, groupId, itemId),
    [getInput]
  );

  const onInputChange = useCallback(
    (groupId: number, itemId: number, value: string, groupTitle?: string, itemTitle?: string) => {
      setInput({ pageKey: PAGE_KEY, groupId, groupTitle, itemId, itemTitle, value });
    },
    [setInput]
  );

  // required by SettingListProps in your project
  const isChecked = useCallback(() => false, []);
  const onToggle = useCallback(() => {}, []);

  return (
    <main>
      {MockSetAttachment.map((group) => (
          <SettingList
            key={group.id}
            groupId={group.id}
            mainTitle={group.title}
            paragraph={group.description}
            setList={group.items}
            isChecked={isChecked}
            onToggle={onToggle}
            getInputValue={getInputValue}
            onInputChange={(groupId, itemId, value) => {
              const item = group.items.find((x) => x.id === itemId);
              onInputChange(groupId, itemId, value, group.title, item?.title);
            }}
          />
        ))
      }
    </main>
  );
};

export default AttahcmentSet;